import React from 'react';
import './add lead.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message, TreeSelect } from "antd";
const TreeNode = TreeSelect

class addLead extends React.Component {
    state = {
        fullname: '',
        phone: '',
        country: null,
        campaign: null,
        broker: null,
        campaigns: [],
        countries:[],
        brokers: []
    };

    constructor(props) {
        super(props)
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }

    componentDidMount() {
        this.getCampaigns()
        this.getCountries()
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }
    getCampaignBrokers = (campaign) => {
        axios.get(`${BASE_END_POINT}campaigns/${campaign}/members/get?limit=1000&justBrokers=true`, {
            headers: {
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            }
        }).then(response => {
            console.log("brokers   ", response.data)
            this.setState({ brokers: response.data.data })
        })
        .catch(error => {
            console.log("error   ", error.response)
            console.log("error2   ", error)
        })
    }
    getCountries = () => {
        axios.get(`${BASE_END_POINT}countries/withoutPagenation/get`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`
            },
        }).then(response => {
            console.log("countries", response.data)
            this.setState({ countries: response.data.data })
        }).catch(error => {
            console.log("ALL countries ERROR")
            console.log(error.response)
        })
    }
    getCampaigns = () => {
        axios.get(`${BASE_END_POINT}campaigns/shortList/get`, {
            headers: {
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            }
        }).then(response => {
            console.log(response.data)
            this.setState({ campaigns: response.data.data })
        })
        .catch(error => {
            console.log("ALL campaigns ERROR")
            console.log(error.response)
        })
    }
    addLead = () => {
        const { fullname, phone, country, campaign, broker } = this.state
        if (hasValue(fullname) && hasValue(phone) && campaign != null && broker != null) {
            let l = message.loading('Wait..', 2.5)
            const data = {
                'fullname': fullname,
                'phone': phone,
                'country': country,
                'broker': broker,
                'campaign': campaign
            }

            axios.post(`${BASE_END_POINT}leads`, JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en'
                },
            })
            .then(response => {
                console.log("lead UPDATED  ", response.data)
                l.then(() => message.success(allStrings.done, 2.5))
                this.props.history.goBack()
            })
            .catch(error => {
                console.log(error.response)
                if (error.response.data.errors.msg[0].msg) {
                    l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))

                } else {
                    l.then(() => message.error(allStrings.error, 2.5))

                }
            })
        }
    }



    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.addLead()
    };

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };


    render() {
        if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('LEADS')) return <Redirect to='/Home' />

        return (
            <div className="App">
                <MDBContainer>
                    <MDBRow>
                        <MDBCol md="12">
                            <div className="infoCard">
                                <Card className="editCard">
                                    <CardMedia
                                        style={{ height: "0px" }}
                                    />
                                    <CardHeader></CardHeader>
                                    <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                                        <div className="topIcon">
                                            <span className="material-icons" style={{ color: 'white', fontSize: 23 }}>contact_phone</span>
                                        </div>
                                        <div className="tableTitle" style={{
                                            display: this.props.isRTL ? 'inline-block' : 'inline-block', marginTop: this.props.isRTL ? '-60px' : '-60px',
                                            marginLeft: this.props.isRTL ? '0' : '7.5rem', marginRight: this.props.isRTL ? '8.5rem' : '0'
                                        }}>
                                            <p>{allStrings.add}</p>
                                        </div>
                                    </div>
                                    <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                                        <MDBContainer>

                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <form
                                                        className="needs-validation"
                                                        onSubmit={this.submitHandler}
                                                        noValidate
                                                    >
                                                        <div className="grey-text">
                                                            <MDBRow style={{flexDirection: this.props.isRTL?'row-reverse':'row'}}>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.name}</label>
                                                                        <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.fullname} type="text" id="form645" name="fullname" className="form-control" onChange={this.changeHandler} required validate />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form56" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.phone}</label>
                                                                        <input onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^0-9+]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.phone} type="text" id="form56" name="phone" className="form-control" onChange={this.changeHandler} required validate />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>

                                                            <MDBRow>
                                                                <MDBCol md="6" sm="6">
                                                                    <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.country}</label>
                                                                    <TreeSelect virtual={false}
                                                                        showSearch={true}
                                                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', height: '35px', marginBottom: '1rem' }}
                                                                        treeCheckable={false}
                                                                        treeNodeFilterProp="title"
                                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                        placeholder={allStrings.country}
                                                                        onChange={(value) => {
                                                                            console.log(value)
                                                                            this.setState({ country: value });
                                                                        }}

                                                                    >
                                                                        {this.state.countries.map(val => (
                                                                            <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                                                                        ))}
                                                                    </TreeSelect>
                                                                </MDBCol>
                                                                <MDBCol md="6" sm="6">
                                                                    <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.campaign}</label>
                                                                    <TreeSelect virtual={false}
                                                                        showSearch={false}
                                                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', height: '35px', marginBottom: '1rem' }}
                                                                        treeNodeFilterProp="title"
                                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                        placeholder={allStrings.campaign}
                                                                        onChange={(value) => {
                                                                            console.log(value)
                                                                            this.setState({ campaign: value });
                                                                            this.getCampaignBrokers(value)
                                                                        }}

                                                                    >
                                                                        {this.state.campaigns.map(val => (
                                                                            <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                                                                        ))}
                                                                    </TreeSelect>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow style={{flexDirection: this.props.isRTL?'row-reverse':'row'}}>
                                                                <MDBCol md="6" sm="6">
                                                                    <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.broker}</label>
                                                                    <TreeSelect
                                                                        virtual={false}
                                                                        showSearch={true}
                                                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', height: '35px', marginBottom: '1rem', }}
                                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                        placeholder={allStrings.broker}
                                                                        onChange={(value) => {
                                                                            console.log(value);
                                                                            this.setState({ broker: value });
                                                                        }}
                                                                    >
                                                                        {this.state.brokers.map((val) => (
                                                                            <TreeNode value={val.id} title={val.fullname} key={val.id} />))}
                                                                    </TreeSelect>
                                                                </MDBCol>
                                                                <MDBCol md="6" sm="6"></MDBCol>
                                                            </MDBRow>
                                                        </div>
                                                        <br></br>
                                                        <br></br>
                                                        <div className="text-center">
                                                            <MDBBtn
                                                                style={{ background: '#E6B659', color: '#fff' }}
                                                                rounded
                                                                color="#E6B659"
                                                                type="submit"
                                                                className="btn-block z-depth-1a"
                                                            >
                                                                <MDBIcon icon="plus" className="mr-2" />
                                                                {allStrings.add}
                                                            </MDBBtn>

                                                        </div>
                                                    </form>
                                                </MDBCol>
                                            </MDBRow>
                                        </MDBContainer>
                                    </CardContent>
                                </Card>
                            </div>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>

            </div>
        )
    }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(addLead)
);